export default __webpack_public_path__ + "9d42b3eba368e36c9963427066fea4de.svg";